import { SET_FAN_GENRES } from './fanTypes';

export const fanReducer = (prevState, action) => {
  switch (action.type) {
    case SET_FAN_GENRES:
      return {
        fanGenres: action.genres,
      };
    default:
      return prevState;
  }
};
